import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { getAccessToken, getCustomerId } from "@/helpers/auth-helpers";
import ICustomerSalesProduct from "@/interfaces/customer-sales-product.interfaces";
import { customerSalesProductService } from "@/services/customer-sales-product.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<ICustomerSalesProduct> | null>;

export type Props = RequestPagination & { enabled?: boolean };

type Params = [string, number, number];

const useGetAllCustomerSalesProducts = ({
  pageNumber,
  pageSize,
  enabled = true,
}: Props): Return => {
  const hasAuth = Boolean(getAccessToken() && getCustomerId());

  const shouldFetch = hasAuth && enabled;

  const fetcher = useSWR<PaginatedResponse<ICustomerSalesProduct>, Error, Params | null>(
    shouldFetch ? [SWR_KEYS.getAllCustomerSalesProducts, pageNumber, pageSize] : null,
    async ([, _pageNumber, _pageSize]) =>
      (await customerSalesProductService.getAll(
        _pageNumber,
        _pageSize
      )) as unknown as PaginatedResponse<ICustomerSalesProduct>,
    {
      revalidateOnFocus: shouldFetch,
      errorRetryCount: 3,
      errorRetryInterval: 5000,
      onError: (swrError) => {
        // eslint-disable-next-line no-console
        console.error("Erro ao buscar customer sales products:", swrError);
      },
    }
  );

  const { data = null, isLoading, isValidating, error } = fetcher;

  return {
    data,
    isLoading: isLoading || (!data && isValidating),
    isValidating,
    error,
  };
};

export default useGetAllCustomerSalesProducts;
